import React from 'react';

const iconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px',
  borderRadius: '8px',
  backgroundColor: '#f3f4f6',
  marginRight: '12px',
  color: '#4b5563'
};

export const AudioSpeedIcon = (props) => (
  <svg
    height={24}
    viewBox="0 0 24 24"
    width={24}
    id="svg6"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs10" />
    <text
      xmlSpace="preserve"
      style={{
        fontSize: "0.133333px",
        lineHeight: 1.25,
        fontFamily: "Arial",
        letterSpacing: 0,
        wordSpacing: 0,
      }}
      x={3.4039314}
      y={20.956221}
      id="text2833"
    >
      <tspan
        id="tspan2831"
        x={3.4039314}
        y={20.956221}
        style={{
          fontSize: "0.133333px",
        }}
      >
        {"Readerum.com"}
      </tspan>
    </text>
    <path
      style={{
        fill: "none",
        stroke: "#000000",
        strokeWidth: 0.5,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      d="m 3.2961039,3.5533347 5.4650962,0.071909"
      id="path1807"
    />
    <path
      style={{
        fill: "none",
        stroke: "#000000",
        strokeWidth: 0.474267,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      d="m 0.49049779,10.665644 3.62119081,0.09764"
      id="path1807-8"
    />
    <path
      style={{
        fill: "none",
        stroke: "#000000",
        strokeWidth: 0.61879,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      d="m 1.9290331,14.836729 6.209217,0.09694"
      id="path1807-8-6"
    />
    <path
      style={{
        fill: "none",
        stroke: "#000000",
        strokeWidth: 0.61344,
        strokeLinecap: "round",
        strokeLinejoin: "miter",
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      d="m 3.5083595,20.874422 5.783112,0.10229"
      id="path1807-8-6-9"
    />
    <path
      style={{
        display: "inline",
        fill: "#ffffff",
        fillOpacity: 1,
        stroke: "#000000",
        strokeWidth: 1,
        strokeLinecap: "butt",
        strokeLinejoin: "round",
        strokeOpacity: 1,
        paintOrder: "normal",
      }}
      d="m 11.251123,7.4708757 7.779661,4.7288133 -7.754238,4.652543 z"
      id="path1799"
    />
    <path
      style={{
        display: "inline",
        fill: "none",
        stroke: "#000000",
        strokeWidth: 1,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeOpacity: 1,
      }}
      d="M 13.938254,3.4622176 C 25.398866,3.4946484 25.64416,20.649632 13.858773,20.679027 2.0733858,20.708422 2.6813137,3.4303631 13.938254,3.4622176 Z"
      id="path2002"
    />
  </svg>
);
